import React from 'react';
import styles from './Leaderboard.module.css';
import clsx from 'clsx';
interface LeaderboardHeaderProps {
  columns : string[]
}
export const LeaderboardHeader: React.FC<LeaderboardHeaderProps> = ({ columns }) => {
  return (
    <div className={clsx(styles.headerContainer , "fontWeightBold fontSizeXs")}>
      <div className={styles.headerContent}>
        {columns.map((column, index) => (
          <div key={index} className={clsx(index==1? styles.headerColumnName : styles.headerColumn)}>
            {column}
          </div>
        ))}
      </div>
    </div>
  );
};